import React from 'react';
import Typography from '@material-ui/core/Typography'
import { Link, List, ListItem, ListItemText } from '@material-ui/core';

export default function ApiDocIntro(props) {
    return (
        <>
            <Typography variant="h6" color="initial">
                <code>Introducción</code>
            </Typography><br />
            <Typography paragraph variant="body2">
                {/* ¿Qué hace tu API?<br /> */}
                La API de Meteorología Santiago de Cuba permite acceder a los principales servicios públicos generados por nuestra Entidad, tales como:
                {/* <List>
                    {['Pronóstico Extendido,', 'Pronóstico por municipios,', 'Imágenesde superficie, satélite y radar,', 'Alertas,', 'Huracanes,', 'y otros.'].map((text, index) => (
                        <ListItem button key={text}>
                            <ListItemText primary={text} />
                        </ListItem>
                    ))}
                </List> */}
                <ul>
                    <li>Pronóstico Extendido,</li>
                    <li>Pronóstico por municipios,</li>
                    <li>Imágenes de superficie, satélite y radar,</li>
                    <li>Alertas,</li>
                    <li>Ciclones Tropicales,</li>
                    <li>entre otros</li>
                </ul>

            </Typography>

            <Typography variant="h6" color="initial">
                <code>Visión general</code>
            </Typography><br />
            <Typography paragraph variant="body2">
                {/* Cosas que los desarrolladores deben saber<br /> */}
                La API de Meteorología Santiago de Cuba es una API basada en JSON. Todas las solicitudes se realizan a los puntos finales a partir de: <Link href="https://www.cmpscu.cu/api" target="_blank">https://www.cmpscu.cu/api</Link> ó <Link href="https://api.cmpscu.cu" target="_blank">https://api.cmpscu.cu</Link> <br />

                Nota: Todas las solicitudes deben ser seguras, es decir, https, no http.
            </Typography>

            {/* <Typography variant="h6" color="initial">
                <code>Autenticación</code>
            </Typography><br />
            <Typography paragraph variant="body2">
                ¿Cuál es la forma preferida de utilizar la API?
            </Typography> */}

            <Typography variant="h6" color="initial">
                <code>Códigos de error</code>
            </Typography><br />
            <Typography paragraph variant="body2">
                {/* ¿Qué errores y códigos de estado puede esperar un usuario?<br /> */}
                En caso de no exitir un recurso determinado solicitado a través de una petición http se devolverá un código de error 404 (Recurso no encontrado).
            </Typography>

            <Typography variant="h6" color="initial">
                <code>Límite de tarifa</code>
            </Typography><br />
            <Typography paragraph variant="body2">
                {/* ¿Existe un límite en la cantidad de solicitudes que puede enviar un usuario?<br /> */}
                No existe un límite en la cantidad de solicitudes que puede enviar un usuario
            </Typography>
        </>
    )
}